import { Link, useLocation } from 'wouter';
import { useState, type ReactNode } from 'react';
import { useAuth } from '@/core/auth/AuthProvider';
import { queryClient } from '@/core/query/queryClient';

const navigation = [
  { to: '/app/guides', label: '攻略管理', icon: '路' },
  { to: '/app/pois', label: 'POI 库', icon: '地' },
  { to: '/app/leads', label: '用户线索', icon: '信' },
];

export function AdminLayout({ children }: { children: ReactNode }) {
  const { logout } = useAuth();
  const [, navigate] = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  async function signOut() {
    await logout();
    queryClient.clear();
    navigate('/', { replace: true });
  }

  return (
    <div className="app-shell">
      <header className="mobile-header">
        <a className="brand-lockup" href="/admin/app/guides">
          <span className="brand-mark brand-mark--small">走</span>
          <strong>走起内容台</strong>
        </a>
        <button
          className="icon-button"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          onClick={() => setMenuOpen((value) => !value)}
        >
          菜单
        </button>
      </header>
      <aside className={`sidebar ${menuOpen ? 'sidebar--open' : ''}`}>
        <a className="brand-lockup sidebar__brand" href="/admin/app/guides">
          <span className="brand-mark brand-mark--small">走</span>
          <span><strong>走起</strong><small>内容运营台</small></span>
        </a>
        <nav id="primary-navigation" aria-label="主要功能">
          {navigation.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setMenuOpen(false)}
              className={(isActive) => isActive ? 'nav-item nav-item--active' : 'nav-item'}
            >
              <span aria-hidden="true">{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="sidebar__footer">
          <p><span className="live-dot" /> 管理会话已加密</p>
          <button className="text-button" onClick={() => void signOut()}>退出登录</button>
        </div>
      </aside>
      <main className="workspace">
        {children}
      </main>
    </div>
  );
}
